import React from 'react';
import styled from 'styled-components';
import EllipsesControl from '../../../../EllipsesControl/EllipsesControl';

export default function StringColumn(params) {
	const {value, width} = params;
	return (
		<StyledStringColumn style={width && {width: width}} className="StyledStringColumn">
			{value ? (
				<span className="text-renderer">
					<EllipsesControl noOfLines={1} content={value} tooltip={value} />
				</span>
			) : (
				<span className="no-value-renderer">-</span>
			)}
		</StyledStringColumn>
	);
}
const StyledStringColumn = styled.section`
	line-height: var(--px-22);
	width: var(--px-350);
	.text-renderer {
		font-size: var(--px-12);
		font-weight: 400;
	}
`;
